export default __webpack_public_path__ + "static/media/Resume.9b89ffe8.svg";